import omit from 'lodash/omit';
import { useSelector } from 'react-redux';
import { boardsProviderKeysSelector } from 'state/selectors/boards';
import { teamsSelector } from 'state/selectors/teams';
import {
  formatCustomField,
  formatFiltersFromDB
} from 'modals/EditCustomPmMetricsModal/EditCustomPmMetricsModal.service';
import { CUSTOM_FIELDS_KEY } from 'modals/EditCustomPmMetricsModal/EditCustomPmMetricsModal.constants';
import { FILTER_TYPES } from 'common/constants/filters';

const usePMMetricsFilters = ({
  graph: { filters },
  issueTypes: { data: issueTypesData }
}) => {
  const orgTeams = useSelector(teamsSelector);
  const allBoards = useSelector(boardsProviderKeysSelector);

  const formattedSelectedFilters = omit(
    formatFiltersFromDB({
      allBoards,
      orgTeams,
      filters,
      issueTypes: issueTypesData
    }),
    FILTER_TYPES.FIELD
  );
  const formattedCustomFields = formatCustomField(
    filters?.[CUSTOM_FIELDS_KEY] ?? []
  );
  return {
    ...formattedSelectedFilters,
    ...formattedCustomFields,
    issue_states: filters?.issue_states ?? []
  };
};

export default usePMMetricsFilters;
